import userRegisterSlice from "../slices/UserRegistrationSlice.ts";
import MasterSlice from "../slices/MasterSlice.ts";
import siteManagementReducer from '../slices/SiteManagementSlice.ts';
import TowerManagementSlice from "../slices/TowerManagementSlice.ts";
// import dashboardReducer from '../slices/dashboardSlice.ts';
import MeterialMasterSlice from "../slices/MeterialMasterSlice.ts";
import materialListMasterSlice from "../slices/MaterialListMasterSlice.ts";
import PriorityMasterSlice from "../slices/PriorityMasterSlice.ts";
import MaterialRequestSlice from "../slices/MaterialRequestSlice.ts";
import materialAllocationSlice from "../slices/MaterialAllocationSlice.ts";
import accessoryMaster from '../slices/AccessorySlice.ts';
import accessoriesListMasterSlice from '../slices/AccessoriesListMasterSlice.ts';
import repetitionReducer from '../slices/RepititionSlice.ts';
import HandOverSlice from '../slices/HandOverslice.ts';

import { configureStore } from "@reduxjs/toolkit";
import ClientSlice from '../slices/ClientSlice.ts';
import vendorSlice from '../slices/VendorSlice.ts';
import RequestSlice from "../slices/RequestSlice.tsx";
import AssignmentSlice from "../slices/AssignmentSlice.ts";
import serviceMasterSlice from '../slices/ServiceMasterSlice.ts';
import subServiceMasterSlice from '../slices/SubServiceMasterSlice.ts';
import dashboardSlice from "../slices/DashboardSlices.ts";
import breadcrumbReducer from '../slices/BreadcrumbSlice.ts';


const store = configureStore({
    reducer: {
        clientSlice: ClientSlice,
        vendorSlice: vendorSlice,
        requestSlice: RequestSlice,
        serviceMaster: serviceMasterSlice,
        subServiceMaster: subServiceMasterSlice,
        assignmentSlice: AssignmentSlice,
        dashboard: dashboardSlice,
        breadcrumb: breadcrumbReducer,



        userRegister: userRegisterSlice,
        MasterSlice:MasterSlice,
        MeterialMasterSlice:MeterialMasterSlice,
        MaterialListMaster: materialListMasterSlice,
        siteManagement: siteManagementReducer,
        towerManagement: TowerManagementSlice,
        // dashboard: dashboardReducer,
        PriorityMasterSlice: PriorityMasterSlice,
        accessoryMaster: accessoryMaster,
        accessoriesListMaster: accessoriesListMasterSlice,
        MaterialRequest:MaterialRequestSlice,
        materialAllocation: materialAllocationSlice,
        repetition: repetitionReducer,
        handOver:HandOverSlice
    }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
